module.exports = __webpack_public_path__ + "img/9.446defe0.jpg";